import loadable from '@loadable/component';
import { Loader } from '@/components';

const AsyncFAQ = loadable(() => import('./FAQ'), {
  fallback: <Loader />,
});

export default AsyncFAQ;
